<template>
    <div>
        <div v-if="!isDone && hasDropdown">
            <CompassSplitButton
                ref="activityUpdateStatusButton"
                data-bot="activity-update-status-button"
                :label="label"
                :type="statusButtonType"
                :class="['status__button', statusButtonClass]"
                :disabled="disabled"
                :loading="pending"
                @clickOnLabel="$emit('updateStatus')"
                @clickOnArrow="showDropdown = !showDropdown"
            />
            <CompassDropdown
                v-model:isVisible="showDropdown"
                v-click-outside="handleDropdownClickOutside"
                parentRef="activityUpdateStatusButton"
                dropdownClass="activity-update-status-button__dropdown"
                placement="top-end"
                :isVisible="showDropdown"
            >
                <CompassDropdownOption
                    :label="
                        $t.__(
                            'activities.detailPanel.ActivityUpdateStatusButton.close_and_create_new_task',
                        )
                    "
                    icon="task"
                    :isCheckable="false"
                    @itemSelected="handleCloseAndCreateNewTaskClick"
                />
            </CompassDropdown>
        </div>
        <CompassButton
            v-else
            data-bot="activity-update-status-button"
            :label="label"
            leftIcon="check"
            :type="statusButtonType"
            :class="['status__button', statusButtonClass]"
            :disabled="disabled"
            :loading="pending"
            @click="$emit('updateStatus')"
        />
    </div>
</template>

<script>
export default {
    props: {
        isDone: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        pending: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        statusButtonType: {
            type: String,
            default: 'primary',
        },
        hasDropdown: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showDropdown: false,
        };
    },
    computed: {
        statusButtonClass() {
            return {
                'status__button--is-done': this.isDone,
                'status__button--is-disabled': this.disabled,
            };
        },
    },
    methods: {
        handleDropdownClickOutside($event = null) {
            if (!$event || !$event.target.closest('.status__button')) {
                this.showDropdown = false;
            }
        },
        handleCloseAndCreateNewTaskClick() {
            this.$emit('updateStatus', true);
            this.showDropdown = false;
        },
    },
};
</script>

<style scoped lang="scss">
.status__button {
    &--is-done:not(.status__button--is-disabled) {
        border-color: var(--colors-common-border-success-darker);
        color: var(--colors-common-text-success-hover);
        &:not(.is-loading):hover {
            background-color: var(--colors-common-background-success-subtle);
        }
        :deep(h6) {
            color: var(--colors-common-text-success-hover);
        }
    }
    &--is-disabled,
    &--is-disabled:hover {
        background-color: var(--colors-common-background-disabled);
    }
}

#compass-dropdown-container {
    .activity-update-status-button__dropdown {
        z-index: 1000;
        width: 286px;
    }
}
</style>
